<template>
    <div class="modal fade" :id="id" tabindex="-1" role="dialog" aria-labelledby="notice" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title"><img class="modal-title-icon" :src="titleIcon" v-show="titleIcon" />{{ title }}</h5>
                </div>
                <div class="modal-body">
                    <slot></slot>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" data-dismiss="modal">{{ button }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Alert',
  props: ['id', 'titleIcon', 'title', 'button']
}
</script>

<style scoped lang="scss">
    @import '../styles/variables';
    .modal-dialog {
        max-width: 440px;
    }
    .modal-header {
        padding: 55px 55px 20px 55px;
        border-bottom: 0;
        .modal-title {
            font-size: 1.375em;
            font-family: $head-semi-bold-font-family;
            .modal-title-icon {
                margin-right: 10px;
                vertical-align: top;
                padding-top: 5px;
            }
        }
        #advancedSettings & {
            padding-bottom: 0;
        }
    }
    .modal-body {
        padding: 0 55px;
        p {
            margin-bottom: 10px;
            font-size: 1em;
            font-family: $body-font-family;
        }
    }
    .modal-footer {
        padding: 20px 55px 55px 55px;
        border-top: 0;
        justify-content: flex-start;
    }

</style>



// WEBPACK FOOTER //
// src/components/Alert.vue